module.exports = __webpack_public_path__ + "h5/img/promoter.d89acb5f.png";